const secondary = {
    social_bind_with: '¿Ya tienes una cuenta? Inicia sesión para vincular {{methods, list(type: disjunction;)}} con tu identidad social.',
};
export default Object.freeze(secondary);
